import React, { Component } from 'react';
import Dashboard from './dashboard';
import Footer from '../layouts/footer';

const THEME_STORAGE_KEY = 'ddir-color-theme';

class Home extends Component {
  // Read any previously-saved preference so a fresh tab/page load (e.g. a
  // WPID item link opened via target="_blank") matches the theme the user
  // already chose, instead of always defaulting to light.
  state = { colorTheme: localStorage.getItem(THEME_STORAGE_KEY) || 'light' };

  handleThemeChange = theme => {
    this.setState({ colorTheme: theme });
    try {
      localStorage.setItem(THEME_STORAGE_KEY, theme);
    } catch (e) {
      console.warn('Failed to persist theme preference:', e);
    }
  };

  render() {
    const { colorTheme } = this.state;
    const isDark = colorTheme === 'dark';

    return (
      <main className={isDark ? 'dark-mode' : ''}>
        <Dashboard
          colorTheme={colorTheme}
          onThemeChange={this.handleThemeChange}
        />
        <Footer colorTheme={colorTheme} />
      </main>
    );
  }
}

export default Home;